// import React from 'react';
// import { Link } from 'react-router-dom';
// import { Card, CardContent, CardHeader, CardTitle } from "@/components/card";
// import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/table";
// import Footer from '../../../components/Footer';
// import BtechImg from "../../../assets/images/engineering.jpeg";

// const programDetails = {
//   name: "Bachelor of Technology in Cyber Security & Forensics",
//   about: "A Bachelor of Technology (B.Tech.) in Cyber Security & Forensics is an undergraduate program designed to provide students with comprehensive knowledge and skills in the field of cyber security, digital forensics, and information security. Graduates are well-equipped to pursue careers such as cyber security analysts, security consultants, forensic analysts, penetration testers, and more. With the increasing frequency of sophisticated cyber attacks, this field offers a promising career path across industries like government, healthcare, technology, and financial institutions.",
//   eligibility: "Intermediate / 10+2 or its equivalent examination with PCM (Physics, Chemistry, Maths) from a recognized Board/ University/ MDU Entrance Examination",
// };

// const programFees = {
//   program: "Bachelor of Technology (B.Tech.)",
//   branch: "Cyber Security & Forensics",
//   duration: "4",
//   seats: "60",
//   registrationFee: "20000",
//   allIndiaFee: "120000",
//   ukDomicileFee: "90000",
// };

// const BtechCyber = () => {
//   return (
//     <div className="w-full relative font-poppins bg-gray-50">
//       <div className="w-11/12 lg:w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5 pb-16">
//         <Card className="border-none shadow-lg">
//           <CardHeader className="space-y-4 text-center">
//             <CardTitle className="text-2xl md:text-6xl tracking-tight font-bold text-center text-[#0e4d38]">
//               {programDetails.name}
//             </CardTitle>
//             <div className="w-20 h-1 bg-[#23376c] mx-auto"></div>
//           </CardHeader>
//           <CardContent>
//             <div className="flex flex-col md:flex-row gap-8 mb-10 md:gap-[80px] mt-5 justify-center md:justify-between">
//               <div className="md:w-[30%] relative group">
//                 <img
//                   src={BtechImg}
//                   className="rounded-lg w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
//                   alt="B.Tech Cyber Security & Forensics"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-lg"></div>
//               </div>
//               <div className="flex flex-col gap-4 md:w-[65%]">
//                 <h4 className="font-bold text-xl md:text-3xl text-[#23376c]">About the Department</h4>
//                 <p className="text-justify md:text-lg text-gray-700 leading-relaxed">{programDetails.about}</p>
//                 <Link to="https://admission.maya.edu.in/">
//                   <button className="mt-5 md:mt-0 bg-[#23376c] px-6 py-3 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] hover:shadow-lg transform hover:-translate-y-1">
//                     Register Now
//                   </button>
//                 </Link>
//               </div>
//             </div>
//           </CardContent>
//         </Card>

//         <Card className="border-none shadow-lg">
//           <CardContent className="mt-5 p-6">
//             <h4 className="text-2xl font-semibold text-[#0e4d38] mb-4">Eligibility Criteria</h4>
//             <p className="text-gray-700 leading-relaxed">{programDetails.eligibility}</p>
//           </CardContent>
//         </Card>

//         {/* Program Fee Table */}
//         <Card className="border-none shadow-lg overflow-hidden">
//           <CardContent className="p-0">
//             <Table>
//               <TableHeader>
//                 <TableRow className="bg-[#23376c]">
//                   <TableHead className="text-white font-semibold">Programme</TableHead>
//                   <TableHead className="text-white font-semibold">Branch</TableHead>
//                   <TableHead className="text-white font-semibold">Duration</TableHead>
//                   <TableHead className="text-white font-semibold">Seats</TableHead>
//                   <TableHead className="text-white font-semibold">Registration Fee</TableHead>
//                   <TableHead className="text-white font-semibold">Yearly Fee (All India)</TableHead>
//                   <TableHead className="text-white font-semibold">Yearly Fee (UK Domicile)</TableHead>
//                 </TableRow>
//               </TableHeader>
//               <TableBody>
//                 <TableRow className="hover:bg-gray-50">
//                   <TableCell className="font-medium">{programFees.program}</TableCell>
//                   <TableCell>{programFees.branch}</TableCell>
//                   <TableCell>{programFees.duration}</TableCell>
//                   <TableCell>{programFees.seats}</TableCell>
//                   <TableCell>{`₹${programFees.registrationFee}/-`}</TableCell>
//                   <TableCell>{`₹${programFees.allIndiaFee}/-`}</TableCell>
//                   <TableCell>{`₹${programFees.ukDomicileFee}/-`}</TableCell>
//                 </TableRow>
//               </TableBody>
//             </Table>
//           </CardContent>
//         </Card>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default BtechCyber;


import React from 'react';
import Footer from '../../../components/Footer';
import BtechImg from "../../../assets/images/engineering.jpeg"; // Update with a relevant cyber security image
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  Shield,
  GraduationCap,
  Lock,
  Target,
  BookOpen,
  FlaskConical,
  MapPin,
  Users,
  Code,
} from 'lucide-react';

const BtechCyber = () => {
  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  return (
    <div className='w-full relative font-poppins'>
      {/* Hero Section */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className='relative h-[300px] md:h-[400px] bg-[#0e4d38] mt-[60px] md:mt-[80px] overflow-hidden'
      >
        <div className='absolute inset-0 bg-black/50'></div>
        <div className='relative z-10 h-full flex flex-col justify-center items-center text-white px-4'>
          <h1 className='text-3xl md:text-6xl font-bold text-center mb-4'>
            Bachelor of Technology in Cyber Security & Forensics
          </h1>
        </div>
      </motion.div>

      <div className='w-11/12 md:w-10/12 mx-auto mt-8 md:mt-16'>
        {/* About Section */}
        <motion.div
          {...fadeIn}
          className='flex flex-col md:flex-row gap-8 mb-10 md:gap-[80px]'
        >
          <img src={BtechImg} className='md:w-[40%] rounded-xl shadow-lg' alt="Cyber Security" />
          <div className='flex flex-col gap-4'>
            <div className='flex items-center gap-3'>
              <div className='p-2 rounded-lg bg-[#0e4d38] text-white'>
                <Shield size={24} />
              </div>
              <h4 className='font-bold text-2xl md:text-3xl text-[#0e4d38]'>Program Overview</h4>
            </div>
            <div className='text-justify md:text-lg space-y-4 text-gray-700'>
              A Bachelor of Technology (B.Tech.) in Cyber Security & Forensics focuses on equipping students with in-depth knowledge of protecting digital systems and investigating cyber crimes. This program blends theoretical concepts with hands-on practices, ensuring that graduates excel in roles such as penetration testers, digital forensic experts, network security engineers, and ethical hackers.
              <br />
              With the exponential rise in cyber threats, this degree opens up lucrative career opportunities in various sectors including government, finance, healthcare, and technology companies.
            </div>
            <Link to="https://admission.maya.edu.in/">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className='mt-5 md:mt-4 bg-[#23376c] px-6 py-3 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] flex items-center gap-2'
              >
                <GraduationCap size={20} />
                Apply Now
              </motion.button>
            </Link>
          </div>
        </motion.div>

        {/* Learning Outcomes */}
        <motion.div {...fadeIn} className='mb-12 bg-white p-6 rounded-xl shadow-lg'>
          <div className='flex items-center gap-3 mb-6'>
            <div className='p-2 rounded-lg bg-[#0e4d38] text-white'>
              <Target size={24} />
            </div>
            <h4 className='font-bold text-2xl text-[#0e4d38]'>Learning Outcomes</h4>
          </div>
          <p className='text-gray-700 leading-relaxed mb-4'>
            The program focuses on providing hands-on experience in securing systems, identifying vulnerabilities, and investigating cyber incidents. Key learning outcomes include:
          </p>
          <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
            {[
              "• Network Security",
              "• Ethical Hacking",
              "• Digital Forensics",
              "• Cryptography",
              "• Cyber Law & Compliance",
              "• Incident Response"
            ].map((role, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.02 }}
                className='p-4 bg-gray-50 rounded-lg border border-gray-200'
              >
                <p className='text-gray-700 font-medium'>{role}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Laboratories and Facilities */}
        <motion.div {...fadeIn} className='mb-12 bg-white p-6 rounded-xl shadow-lg'>
          <div className='flex items-center gap-3 mb-6'>
            <div className='p-2 rounded-lg bg-[#0e4d38] text-white'>
              <Code size={24} />
            </div>
            <h4 className='font-bold text-2xl text-[#0e4d38]'>Laboratories and Facilities</h4>
          </div>

          <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
            {[
              "• Cyber Security Lab",
              "• Network Simulation Lab",
              "• Ethical Hacking Lab",
              "• Digital Forensics Lab",
              "• Cryptography Lab",
              "• IoT Security Lab"
            ].map((lab, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.02 }}
                className='p-4 bg-gray-50 rounded-lg border border-gray-200'
              >
                <p className='text-gray-700 font-medium'>{lab}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Admission Requirements */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-white p-6 rounded-xl shadow-lg mb-12"
        >
          <div className="flex items-center gap-3 mb-6">
            <div className="p-2 rounded-lg bg-[#0e4d38] text-white">
              <GraduationCap size={24} />
            </div>
            <h4 className="font-bold text-2xl text-[#0e4d38]">Admission Requirements</h4>
          </div>

          <div className="space-y-4">
            <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg">
              <div className="w-2 h-2 bg-[#23376c] rounded-full"></div>
              <p className="text-gray-700">
                <span className="font-semibold">Duration of the Program:</span> 4 Years (Semester System)
              </p>
            </div>

            <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg">
              <div className="w-2 h-2 bg-[#23376c] rounded-full"></div>
              <p className="text-gray-700">
                <span className="font-semibold">Affiliation:</span> Constituent College of Maya Devi University
              </p>
            </div>

            <div className="flex items-start gap-3 bg-gray-50 p-4 rounded-lg">
              <div className="w-2 h-2 bg-[#23376c] rounded-full mt-2"></div>
              <p className="text-gray-700">
                <span className="font-semibold">Eligibility Criteria:</span> Candidate shall have Passed 12th Examination with Physics, Chemistry, and Mathematics subjects and should have obtained at least 45% in case of general category and 40% in case of reserved category from a recognized board.
              </p>
            </div>

            <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg">
              <div className="w-2 h-2 bg-[#23376c] rounded-full"></div>
              <p className="text-gray-700">
                <span className="font-semibold">Mode of Admission:</span> As per university procedure
              </p>
            </div>
          </div>
        </motion.div>
      </div>
      <Footer />
    </div>
  );
};

export default BtechCyber;
